import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapEventFromServer = getDataMapper({
    id: mapField("id", Number),
    createdAt: mapField("created_at", (value) => value && new Date(value)),
    data: mapField("data", {
        status: mapField("status", String),
        fio: mapField("human", String),
        humanId: mapField("employee_id", Number),
        point: mapField("point", String),
        rentId: mapField("rent_id", Number),
        rentNumber: mapField("rent_number", String),
        repairState: mapField("repair_state", String),
        serviceFrom: mapField("service_from", String),
        sum: mapField("sum", Number),
        timeStart: mapField("time_start", String),
        timeEnd: mapField("time_end", String),
        daysLeft: mapField("days_left", Number),
        autoPayment: mapField("auto_payment", Boolean),
        tariffTitle: mapField("tariff_title", String),
        inventories: mapField("inventories", {
            id: mapField("id", Number),
            title: mapField("title", String),
        }),
    }),
});

export const mapEventsFromServer = mapArray(mapEventFromServer);
